import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";

const DeleteIcon = () => <FontAwesomeIcon icon={["fas", "trash"]}/>

export default DeleteIcon;